import { Box, Typography } from '@mui/material';

interface StepProgressIndicatorProps {
  currentStep: number;  // 1-5
  totalSteps: number;   // Always 5
}

/**
 * StepProgressIndicator - Shows current step and progress dots
 * 
 * Displays "Step X of Y" text and visual progress dots
 */
export function StepProgressIndicator({ currentStep, totalSteps }: StepProgressIndicatorProps) {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 2,
      mt: 4,
      mb: 3,
    }}>
      {/* Step Text */}
      <Typography 
        variant="body2" 
        sx={{ 
          color: '#6B6B6B',
          fontSize: '14px',
        }}
      >
        Step {currentStep} of {totalSteps}
      </Typography>

      {/* Progress Dots */}
      <Box sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'center',
      }}>
        {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => (
          <Box
            key={step}
            sx={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              bgcolor: step <= currentStep ? '#1A2332' : '#E0E0E0',
              transition: 'background-color 300ms ease',
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
